/**
 * LayoutAuth — layout exclusivo para rotas autenticadas.
 *
 * Copiado de hay-hotspot/assets/reactweb/src/pages/Layout/LayoutAuth.js (Fase 1.6) — 100%
 * genérico, sem mudanças. Guarda de rota: redireciona para /login se não houver token em
 * localStorage["auth"].
 */
import React, { Component } from 'react';
import { Outlet, Navigate } from 'react-router';

import AppSidebar from '../../components/ui/AppSidebar';
import AppToolbar from '../../components/ui/AppToolbar';
import AppThemeConfigurator from '../../components/ui/AppThemeConfigurator';
import { UtilService } from 'hay-core-react';
import { rotasPermitidas, grupos } from '../../service/RotasService';

class LayoutAuth extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sidebarVisible: false,
      configuratorVisible: false,
    };
  }

  render() {
    const { sidebarVisible, configuratorVisible } = this.state;

    const auth = UtilService.getLocalStorage('auth');

    if (!auth?.token) {
      return <Navigate to="/login" replace />;
    }

    const traduzir = (chave) => UtilService.traduzir(chave);

    const agrupados = {};
    const soltos = [];

    Object.entries(rotasPermitidas(this.props.permissoes))
      .filter(([, cfg]) => !cfg.sidebarOculto)
      .forEach(([, cfg]) => {
        const item = { path: cfg.rota, icon: cfg.icone, label: traduzir(cfg.identidade + '.plural') };
        if (cfg.grupo && grupos[cfg.grupo]) {
          (agrupados[cfg.grupo] = agrupados[cfg.grupo] || []).push(item);
        } else {
          soltos.push(item);
        }
      });

    const menuItems = [
      ...soltos.map(item => ({ tipo: 'item', ...item })),
      ...Object.entries(agrupados).map(([key, itens]) => ({
        tipo: 'grupo',
        key,
        label: traduzir(grupos[key].label),
        icon: grupos[key].icone,
        itens,
      })),
    ];

    return (
      <div style={{ display: 'flex', height: '100%' }}>
        <AppSidebar
          auth={auth}
          menuItems={menuItems}
          visible={sidebarVisible}
          onHide={() => this.setState({ sidebarVisible: false })}
        />
        <div style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          marginLeft: sidebarVisible ? '280px' : '0',
          transition: 'margin-left 0.3s',
        }}>
          <AppToolbar
            auth={auth}
            onToggleSidebar={() => this.setState(s => ({ sidebarVisible: !s.sidebarVisible }))}
            onToggleConfigurator={() => this.setState(s => ({ configuratorVisible: !s.configuratorVisible }))}
          />
          <main style={{ flex: 1, overflow: 'auto', backgroundColor: '#343A40' }}>
            <Outlet />
          </main>
        </div>

        <AppThemeConfigurator
          visible={configuratorVisible}
          onHide={() => this.setState({ configuratorVisible: false })}
        />
      </div>
    );
  }
}

export default LayoutAuth;
